import type { Candidate, Job } from '@core/types';

function normSet(arr: string[] | null | undefined): Set<string> {
  return new Set(
    (arr ?? [])
      .map((s) => String(s).trim().toLowerCase())
      .filter(Boolean)
  );
}

export interface SkillOverlapFitment {
  fitment_score: number;
  fitment_json: Record<string, unknown>;
}

/**
 * MAT-030: simple overlap of candidate `parsed_skills` vs job `skills_required` → 0–100.
 * Returns null when the job lists no required skills (nothing to score against).
 */
export function computeSkillOverlapFitment(
  candidate: Candidate,
  job: Job
): SkillOverlapFitment | null {
  const required = normSet(job.skills_required);
  if (required.size === 0) return null;

  const cand = normSet(candidate.parsed_skills);
  const matched: string[] = [];
  for (const r of required) {
    if (cand.has(r)) matched.push(r);
  }
  const missing = [...required].filter((x) => !cand.has(x));
  const score = Math.round((matched.length / required.size) * 100);

  return {
    fitment_score: score,
    fitment_json: {
      kind: 'bulk_skill_overlap',
      matched,
      missing,
      required_count: required.size,
      matched_count: matched.length,
    },
  };
}
